import { PublicClientApplication,LogLevel } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "490a2707-a708-440f-b173-9b8e42644e0e",
    authority: `https://login.microsoftonline.com/714b12a9-398a-4d36-98ff-d36c67bd1e93`, 
    redirectUri: '/', 
    postLogoutRedirectUri: '/logout',
    navigateToLoginRequestUrl: false,
  },
  cache: {
      cacheLocation: 'localStorage', 
      storeAuthStateInCookie: true, 
  },
  system: {
      loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
              if (containsPii) {
                  return;
              }
              switch (level) {
                  case LogLevel.Error:
                      console.error(message);
                      return;
                  case LogLevel.Info:
                      console.info(message);
                      return;
                  case LogLevel.Verbose:
                      console.debug(message);
                      return;
                  case LogLevel.Warning:
                      console.warn(message);
                      return;
                  default:
                      return;
              }
          },
      },
  },
};
/**
 * Scope exposed by the HUB API app registration — the audience the back end validates.
 * @type {string}
 */
const API_SCOPE = "api://c541de31-3e17-4b44-9d4a-70e7525da772/access_as_user";

/**
 * Microsoft Graph scopes; the back end uses the Graph token to read the user's profile and groups.
 * @type {string[]}
 */
const GRAPH_SCOPES = ["user.read"];

class LoginRequest{
  static loginRequest = {
    scopes: [API_SCOPE],
    prompt: "select_account"
};
static graphRequest = {
  scopes: GRAPH_SCOPES
};
static apiRequest = {
  scopes: [API_SCOPE]
};
static silentRequest = {
  scopes: ["openid", "profile"],
  loginHint: "example@domain.net"
};
}

export const msalInstance = new PublicClientApplication(msalConfig);
export default LoginRequest;
